<template>
  <v-content :style="{color:style.fontColor}" v-if="userIsAuthenticated">
    <v-container>
      <v-row class="pl-5 pr-5" >
        <v-col>
          <v-form @submit.prevent="onCreateCategory">
            <v-row>
              <v-col cols="12">
                <h1 class="font-weight-bold" :style="`color:${mainColor}`">Ingresa una nueva categoría</h1>
                <v-row class="mt-5 mb-5"  >
                  <v-col cols="6">
                    <v-card>
                      <v-card-title>
                        <h3>Nombre de la categoría</h3>
                      </v-card-title>
                      <v-row class="pa-4" >
                        <v-col>
                          <v-text-field
                            v-model="categoryName"
                            name="categoryName"
                            id="categoryName"
                            :counter="max3"
                            :rules="[rules.counter3, rules.required]"
                            type="text"
                            filled
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="3" offset="3">
                    <h3 class="mb-3">Estado de la categoría</h3>
                    <p style="font-weight: bold">
                      Estado:
                    </p>
                    <v-select
                      v-model="status"
                      :items="statusSelect"
                      @change="changeStatus"
                      class="mb-4 mr-5"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-card>
                      <v-row>
                        <v-col class="pt-0 mt-4 mb-4" cols="6" :style="{borderRight:style.border}">
                          <v-row>
                            <v-col class="pt-0">
                              <v-card-title>
                                <h3>Keywords</h3>
                              </v-card-title>
                              <v-card-text>
                                <p>Agrega palabras claves para ser usadas en las búsquedas, como ser hombre, zapato, deportivo, negro, etc. Ten cuidado con la ortografía y utiliza sólo el singular.</p>
                              </v-card-text>
                            </v-col>
                          </v-row>
                          <v-row class="pb-4 pl-6 pr-6" >
                            <v-combobox
                              v-model="keywords"
                              hide-selected
                              label="Escribe la keyword y preciona enter"
                              multiple
                              persistent-hint
                              small-chips
                              deletable-chips
                            ></v-combobox>
                          </v-row>
                        </v-col>
                        <v-col class="pl-3 pt-0 mt-4" cols="6" >
                          <v-row>
                            <v-col cols="12"  class="pt-0">
                              <v-card-title>
                                <h3>Selecciona la categoría</h3>
                              </v-card-title>
                              <v-row class="pl-4 pt-4 pr-6">
                                <v-col cols="12">
                                  <v-select
                                      v-model="parentCategoryName"
                                      :items="categoriesSelect"
                                      label="Elige una categoría"
                                      @change="addCategory"
                                      solo
                                  ></v-select>
                                </v-col>
                            </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <template>
                  <v-spacer></v-spacer>
                  <loading-dialog :onLoading="onLoading" />
                </template>
                <template>
                  <load-image-dialog
                    :LoadImageDialogProps="LoadImageDialogProps"
                    :companyId="companyId"
                  />
                </template>
                <template>
                  <load-video-dialog
                    :LoadVideoDialogProps="LoadVideoDialogProps"
                    :companyId="companyId"
                  />
                </template>
              </v-col>
            </v-row>
            <v-row class="mb-5">
              <v-col cols="12">
                <v-card>
                  <v-row>
                    <v-col cols="12" class="pt-0">
                      <v-card-title>
                        <h3>Descripción corta</h3>
                      </v-card-title>
                      <v-row>
                        <v-col class="pb-4" cols="8" offset="2">
                          <v-textarea
                            v-model="shortDescription"
                            name="short description"
                            label ="Escribe una descripción de máximo 80 caracteres, para las tarjetas de messenger."
                            :counter="max1"
                            :rules="[rules.counter1]"
                            multi-line
                            outlined
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <!-- <v-row  >
                    <v-col cols="12">
                      <v-card-title>
                        <h3>Descripción larga</h3>
                      </v-card-title>
                      <v-row>
                        <v-col class="pb-4" cols="8" offset="2" >
                          <v-textarea
                            v-model="longDescription"
                            name="large description"
                            label="Escribe una descripción larga del producto para la vista web."
                            :counter="max2"
                            :rules="[rules.counter2]"
                            multi-line
                            outlined
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row> -->
                </v-card>
              </v-col>
            </v-row>
            <v-row class="mb-5" >
              <v-col>
                <v-card>
                  <v-card-title>
                    <h3>Imagen principal</h3>
                  </v-card-title>
                  <v-row class="mt-4 pb-5" >
                    <v-col cols="6" offset="3">
                      <v-tooltip
                        bottom
                      >
                        <template v-slot:activator="{on}">
                          <v-img
                            @click="loadImage()"
                            :src="imageUrl === '' ? addImageIcon : imageUrl"
                            height="250"
                            contain
                            style="cursor:pointer"
                            v-on="on"
                            eager
                          ></v-img>
                        </template>
                        <span>{{imageUrl === '' ? 'Agregar imagen' : 'Cambiar imagen'}}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <!-- <v-row class="mb-5" >
              <v-col>
                <v-card>
                  <v-card-title>
                    <h3>Video principal</h3>
                  </v-card-title>
                  <v-row class="mt-4 pb-5">
                    <v-col cols="6" offset="3">
                      <v-tooltip
                        bottom
                      >
                        <template v-slot:activator="{on}">
                          <v-row v-on="on" justify="center">
                          <v-img
                            v-show="videoUrl === ''"
                            @click="loadVideo()"
                            :src="addVideoIcon"
                            height="250"
                            contain
                            style="cursor:pointer"
                            eager
                          />
                          <video
                            v-show="videoUrl !== ''"
                            @click="loadVideo()"
                            :src="videoUrl"
                            height="250"
                            style="cursor:pointer"
                            preload="metadata"
                            controls
                          ></video>
                          </v-row>
                        </template>
                        <span>{{videoUrl === '' ? 'Agregar video' : 'Cambiar video'}}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row> -->
            <!-- <v-row class="mb-5" >
              <v-col>
                <v-card>
                  <v-card-title>
                    <h3>Galería principal de imágenes</h3>
                  </v-card-title>
                  <template>
                    <gallery
                      :gallery="gallery"
                      :rules="rules"
                      :max1="max1"
                      :max3="max3"
                      :companyId="companyId"
                    />
                  </template>
                </v-card>
              </v-col>
            </v-row> -->
            <!-- <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    <h3>Base de conocimiento</h3>
                  </v-card-title>
                  <v-card-text>
                    <p>
                      En esta sección podrás agregar información extra referente a la categoría en cuestión.
                      <br />De esta forma el bot podrá acceder a esta información para aclarar las dudas de tus usuarios.
                    </p>
                  </v-card-text>
                  <template>
                    <flow-components
                      :flowComponents="flowComponents"
                      :rules="rules"
                      :max1="max1"
                      :max2="max2"
                      :max3="max3"
                      :companyId="companyId"
                    />
                  </template>
                </v-card>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col class="text-right pa-0" cols="12" >
                <v-btn
                  type="submit"
                  :disabled="onLoading"
                  dark
                  :color="mainColor"
                  small
                  fixed
                  style="top: 65px; right: 15px;"
                >
                  Guardar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
/* eslint-disable no-console */
import * as util from '../../util'
import * as constants from '../../../constants.json'
import { mdiCached } from '@mdi/js'

export default {
  props: ['companyId'],
  data () {
    return {
      categoryName: '', // The category name.
      status: 'Borrador', // The prouct status: draft, published, down.
      shortDescription: '', // A short description of the category. Max  caracter: 80.
      longDescription: '', // A long description of the category. Max  caracter: 1500.
      imageUrl: '',
      videoUrl: '',
      gallery: [{ // The gallery image of the category.
        image: '',
        imageUrl: '',
        title: '',
        subtitle: ''
      }],
      // flowComponents: [ // The knowledge base of the category.
      //   {
      //     selectContentType: '', // Type of the content: description, image, video or gallery.
      //     title: '',
      //     description: '',
      //     gallery: [
      //       {
      //         image: '',
      //         imageUrl: '',
      //         title: '',
      //         subtitle: ''
      //       }
      //     ],
      //     keywords: [],
      //     imageUrl: '',
      //     videoUrl: '',
      //     showOnWeb: false
      //   }
      // ],
      categories: [], // All the categories ids related to this category. They are assigned when the parent category is chosen.
      keywords: [], // String values that represent the main characteristics of the category, some values are autogenerated.
      parentCategory: { name: null, id: null }, // The parent category of this category.
      categoryId: '', // Category Id
      // ---------------------------------------------
      parentCategoryName: '', // The parent category name of this category.
      relationshipsMap: {}, // A map containing all the relationships between categories.
      relationship: {}, // An object that contains the new categories relationship created. It has the prop. caregoryId & parentId.
      categoriesNames: {}, // A map containing all the category's names. categoryId: categoryName.
      categoriesMap: [], // Aux that helps generate the categories select values.
      categoriesSelect: ['0 Categoría padre'], // Array of categories names to be selected as parent categories.
      categoryChanged: false, // A flag that indicates the parent category has been changed.
      formerParentId: null, // The former parent id when the parentIs has been changed.
      statusChanged: false, // // A flag that indicates the status has been changed.
      statusSelect: ['Borrador', 'Publicado', 'Baja'], // Status values to be selected.
      pickFile: { index: null, zone: null }, // Auxiliar index that point to the actual content block that uploads new content (images, videos)
      max1: 80, // Short description Max character allowed in manychat card subtitle
      max2: 1500, // Flow text, Max character allowed in manychat
      max3: 80, // Max character allowed in manychat card title
      mainColor: constants.MAINCOLOR,
      style: {
        border: '1px solid #e1e1e1',
        fontColor: '#525252'
      },
      errors: [], // The user's errors.
      addImageIcon: constants.ADD_IMAGE_ICON,
      addVideoIcon: constants.ADD_VIDEO_ICON,
      LoadImageDialogProps: { loadDialog: false, imageUrl: null }, // Properties to be sent to the LoadImageDialog component.
      LoadVideoDialogProps: { // Properties to be sent to the LoadVideoDialog component.
        loadDalog: false,
        videoUrl: null
      },
      cacheIcon: mdiCached,
      // --------------------------------------------
      rules: {
        counter1: value =>
          (value || '').length <= this.max1 ||
          `Sólo se permite un máximo de ${this.max1} caracteres`,
        counter2: value =>
          (value || '').length <= this.max2 ||
          `Sólo se permite un máximo de ${this.max2} caracteres`,
        counter3: value =>
          (value || '').length <= this.max3 ||
          `Sólo se permite un máximo de ${this.max3} caracteres`,
        required: value => !!value || 'Campo requerido'
      }
    }
  },

  computed: {

    /**
     * Show the Loading animation.
     */
    onLoading () {
      return this.$store.getters.getLoading
    },

    /**
     * Get user object.
     * @returns the user object.
     */
    user () {
      return this.$store.getters.getUser
    },

    /**
     * Verify if the user is authenticated.
     * @returns true if user is authenticated.
     */
    userIsAuthenticated () {
      return (
        this.$store.getters.getUser !== null &&
        this.$store.getters.getUser !== undefined
      )
    }
  },

  watch: {
    /**
     * If no user exists we load the main view.
     */
    user (value) {
      // eslint-disable-next-line
      console.log("hola", value);
      if (value === null || value === undefined) {
        this.$router.push('/')
      }
    },

    /**
     * If a new image has been loaded we add it to the correspondent property
     */
    'LoadImageDialogProps.imageUrl': function (val) {
      this.imageUrl = this.LoadImageDialogProps.imageUrl
    },

    // If a new video has been loaded we add it to the correspondent property.
    'LoadVideoDialogProps.videoUrl': function (val) {
      this.videoUrl = this.LoadVideoDialogProps.videoUrl
    },

    /**
     * Modifyin keywords when name has changed.
     */
    async categoryName (value, oldValue) {
      // Verifying if name already exists in database.
      let nameExists = false
      for (let key in this.categoriesNames) {
        if (this.categoriesNames[key] === value) {
          this.categoryName = ''
          nameExists = true
        }
      }
      if (nameExists) {
        alert('Ya existe una categoría con ese nombre')
      } else if (this.parentCategory.name) {
        if (this.parentCategory.name === value) {
          await this.$nextTick()
          this.categoryName = ''
          alert('Elige otro nombre de categoría distinto al de la categoría padre.')
        }
      }
      // Deleting the old name from keywords and pushing the new one.
      const oldLowerCase = oldValue.toLowerCase()
      const valueLowerCase = value.toLowerCase()
      if (this.keywords.length > 0) {
        if (oldValue) {
          if (this.keywords.indexOf(oldLowerCase) !== -1) {
            this.keywords.splice(this.keywords.indexOf(oldLowerCase), 1)
          }
          if (value !== '') this.keywords.push(valueLowerCase)
        }
      } else {
        if (value !== '') this.keywords.push(valueLowerCase)
      }
    }
  },

  /**
   * Create view and observe data
   */
  async created () {
    // Fetching the data when the view is created and the data is already being observed
    await this.fetchData()
  },

  methods: {
    /**
     * Fetch data
     */
    async fetchData () {
      try {
        // Creating a new category doc to asign its id to its parent category.
        if (localStorage.categoryId === 'null') {
          console.log('localStorage.categoryId', localStorage.categoryId)
          const categoryData = {
            categoryName: 'Sin nombre',
            status: '',
            shortDescription: this.shortDescription,
            longDescription: this.longDescription,
            imageUrl: this.imageUrl,
            videoUrl: this.videoUrl,
            gallery: this.gallery,
            // flowComponents: this.flowComponents,
            categories: this.categories,
            keywords: this.keywords,
            parentCategory: this.parentCategory,
            creationDate: new Date(),
            modificationDate: '',
            companyId: this.companyId
          }
          this.status === 'Borrador' ? categoryData.status = 'draft' : this.status === 'Publicado' ? categoryData.status = 'published' : categoryData.status = 'down'

          const loadedCategory = await this.$store.dispatch(
            'actionCreateUpdateCategory',
            categoryData
          )
          localStorage.categoryId = loadedCategory.categoryId
          this.categoryId = loadedCategory.categoryId
        } else {
          this.categoryId = localStorage.categoryId
          console.log('localStorage.categoryId', localStorage.categoryId)
        }

        // Creating category selector.
        await this.$store.dispatch('actionsLoadRelationshipsMap', {
          companyId: this.companyId
        })
        this.relationshipsMap = this.$store.getters.getRelationShipsMap
        this.categoriesNames = this.$store.getters.getCategoriesNames

        // Generate the category map.
        if (!util.objIsEmpty(this.relationshipsMap)) {
          let categoryMap = util.generateCategoryMap(this.relationshipsMap, this.categoriesNames, this.id)

          // Generate the category selector from the category map.
          const catMapArr = []
          util.generateCategorySelector(categoryMap, catMapArr)
          this.categoriesMap = catMapArr
          this.categoriesMap.forEach(el => {
            this.categoriesSelect.push(el.name)
          })
        }

        // Loading media
        await this.$store.dispatch('actionLoadMedia', {
          companyId: this.companyId
        })
      } catch (error) {
        throw error
      }
    },
    /**
     * Create a new category
     */
    async onCreateCategory () {
      // Load all data to the categoryData object and send it to actionCreateUpdateCategory to store the data on firestore and mutate the state.
      const categoryData = {
        categoryName: this.categoryName,
        status: '',
        shortDescription: this.shortDescription,
        longDescription: this.longDescription,
        imageUrl: this.imageUrl,
        videoUrl: this.videoUrl,
        gallery: [...this.gallery],
        // flowComponents: [...this.flowComponents],
        categories: [...this.categories],
        keywords: [...this.keywords],
        parentCategory: this.parentCategory,
        creationDate: new Date(),
        modificationDate: '',
        companyId: this.companyId,
        categoryId: localStorage.categoryId
      }
      this.status === 'Borrador' ? categoryData.status = 'draft' : this.status === 'Publicado' ? categoryData.status = 'published' : categoryData.status = 'down'

      // Verify errors and update the content.
      if (this.errors.length > 0) {
      // eslint-disable-next-line
        console.log(this.errors);
        alert(`Tienes errores que corregir: ${this.errors}`)
      } else if (this.parentCategoryName === '') {
        alert('Selecciona una categoría padre antes de guardar.')
      } else {
        try {
          console.log('this.relationship', this.relationship)

          // Updating database
          console.log('categoryData: ', categoryData)
          const loadedCategory = await this.$store.dispatch('actionCreateUpdateCategory', {
            parentId: this.parentCategory.id,
            formerParentId: this.formerParentId,
            newParentId: this.relationship.parentId,
            categoryChanged: this.categoryChanged,
            statusChanged: this.statusChanged,
            relationshipCategoryId: this.relationship.categoryId,
            relationshipParentId: this.relationship.parentId,
            ...categoryData
          })

          // Loading data to the edit category page.
          // eslint-disable-next-line
          console.log('loadedCategory', loadedCategory);
          if (!this.onLoading) {
            this.$router.push({
              name: 'EditCategory',
              params: {
                loadedCategory: loadedCategory,
                companyId: this.companyId,
                id: this.categoryId
              }
            })
          }
        } catch (error) {
          throw error
        }
      }
    },

    /**
     * Assigning category name to category and keywords arrays.
     */
    async addCategory () {
      this.categoryChanged = true
      // eslint-disable-next-line
      console.log(this.parentCategory);
      // Verify if the category name has been set before choosing the parent category.
      if (this.categoryName) {
        // Verify that the category name is different than the parent category name selected.
        if (
          this.parentCategoryName.slice(
            this.parentCategoryName.indexOf(' ') + 1
          ) === this.categoryName
        ) {
          await this.$nextTick()
          this.parentCategoryName = null
          alert(
            'Elige otro nombre de categoría distinto al de la categoría padre.'
          )

        // Parent category is equal to '0 Categoría padre'.
        } else if (this.parentCategoryName === '0 Categoría padre') {
          // Creating realationship.
          const formerParentId = this.parentCategory.id
          this.parentCategory.id = 'none'
          this.parentCategory.name = 'none'
          this.relationship.parentId = 'none'
          this.relationship.categoryId = localStorage.categoryId
          // eslint-disable-next-line
          console.log('this.relationship', this.relationship);

          // Deleting keywords and ids related to former category id if the user has changed the parent category.
          if (this.keywords.length !== 0 && formerParentId && formerParentId !== 'none') {
            // eslint-disable-next-line
            console.log('formerParentId', formerParentId);
            if (this.keywords.indexOf(this.categoriesNames[formerParentId]).toLowerCase() !== -1) {
              this.keywords.splice(this.keywords.indexOf(this.categoriesNames[formerParentId]).toLowerCase(), 1)
            }
            this.categories.splice(this.categories.indexOf(formerParentId, 1))
            util.deleteCategoriesAndKeywords(
              this.relationshipsMap,
              this.categoriesNames,
              formerParentId,
              this.keywords,
              this.categories
            )
          }
        // Parent category is any other category
        } else {
          // Creating realationship.
          const formerParentId = this.parentCategory.id
          this.parentCategory.name = this.parentCategoryName.slice(this.parentCategoryName.indexOf(' ') + 1)
          this.parentCategory.id = this.categoriesMap[this.categoriesMap.findIndex(el => el.name === this.parentCategoryName)].id
          this.relationship.parentId = this.parentCategory.id
          this.relationship.categoryId = localStorage.categoryId
          // eslint-disable-next-line
          console.log('this.parentCategory', this.parentCategory);
          // eslint-disable-next-line
          console.log('this.relationship', this.relationship);

          // Deleting keywords and ids related to categories doc if the user has changed the parent category.
          if (this.keywords.length !== 0 && formerParentId && formerParentId !== 'none') {
            // eslint-disable-next-line
            console.log('formerParentId', this.formerParentId);
            if (this.keywords.indexOf(this.categoriesNames[formerParentId].toLowerCase()) !== -1) {
              this.keywords.splice(this.keywords.indexOf(this.categoriesNames[formerParentId].toLowerCase()), 1)
            }
            this.categories.splice(this.categories.indexOf(formerParentId), 1)
            util.deleteCategoriesAndKeywords(
              this.relationshipsMap,
              this.categoriesNames,
              formerParentId,
              this.keywords,
              this.categories
            )
          }

          // Adding the category tree to 'keywords' and 'categories' arrays.
          let parentNameExists = false
          let ownNameExists = false
          this.keywords.forEach(el => {
            if (this.categoriesNames[this.parentCategory.id].toLowerCase() === el) {
              parentNameExists = true
            } else if (this.categoryName.toLowerCase() === el) {
              ownNameExists = true
            }
          })
          if (!parentNameExists) {
            this.keywords.push(this.categoriesNames[this.parentCategory.id].toLowerCase())
          }
          if (!ownNameExists) {
            this.keywords.push(this.categoryName.toLowerCase())
          }
          this.categories.push(this.parentCategory.id)
          util.addCategoryToKeyword(
            this.relationshipsMap,
            this.categoriesNames,
            this.parentCategory.id,
            this.keywords,
            this.categories
          )
          // eslint-disable-next-line
          console.log('this.categories', this.categories);
          // eslint-disable-next-line
          console.log('this.keywords', this.keywords);
        }
      } else {
        alert('Inserta primero un nombre de categoría.')
        await this.$nextTick()
        this.parentCategoryName = null
      }
    },

    /**
     * Set the statudChanged flag
     */
    changeStatus () {
      this.statusChanged = true
    },

    /**
     * Call the load-image-dialog component
     */
    loadImage () {
      this.LoadImageDialogProps.loadDialog = true
    },

    /**
     * Call the load-video-dialog component
     */
    loadVideo () {
      this.LoadVideoDialogProps.loadDialog = true
    }
  }
}
// TODO's:
// Agregar mensaje de alerta antes de eliminar un contenido y en errores
</script>
